'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Action } from '../Action';
import { Icon } from '../Icon';
import { ButtonContainer, CalloutButton } from './elements';
const ActionsOrLink = ({
  primaryButton,
  secondaryButton,
  primaryAction,
  secondaryAction,
  linkOne
}) => {
  const hasPrimaryButton = !!primaryButton;
  const hasSecondaryButton = !!secondaryButton;
  const hasPrimaryAction = !!primaryAction;
  const hasSecondaryAction = !!secondaryAction;
  const {
    text: primaryButtonText,
    ...primaryButtonRest
  } = primaryButton || {};
  const {
    text: secondaryButtonText,
    ...secondaryButtonRest
  } = secondaryButton || {};
  const {
    text: primaryActionText,
    ...primaryActionRest
  } = primaryAction || {};
  const {
    text: secondaryActionText,
    ...secondaryActionRest
  } = secondaryAction || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasPrimaryButton && /*#__PURE__*/React.createElement(CalloutButton, _extends({
    color: "secondary",
    size: "small",
    variant: "outline",
    iconSrc: undefined,
    iconSide: "right",
    disabled: false
  }, primaryButtonRest), primaryButtonText), hasSecondaryButton && /*#__PURE__*/React.createElement(CalloutButton, _extends({
    color: "secondary",
    size: "small",
    variant: "flat",
    iconSrc: undefined,
    iconSide: "right",
    disabled: false
  }, secondaryButtonRest), secondaryButtonText), hasPrimaryAction && /*#__PURE__*/React.createElement(Action, _extends({
    size: "sm",
    variant: "outline"
  }, primaryActionRest), primaryActionText), hasSecondaryAction && /*#__PURE__*/React.createElement(Action, _extends({
    size: "sm",
    variant: "flat"
  }, secondaryActionRest), secondaryActionText), !hasPrimaryButton && !hasSecondaryButton && !hasPrimaryAction && !hasSecondaryAction && linkOne && /*#__PURE__*/React.createElement(Action, {
    size: "sm",
    variant: "flat",
    href: linkOne.href,
    color: "primary",
    onClick: linkOne.onClick
  }, linkOne.text));
};
const CompressButton = ({
  isCompressed,
  onClick
}) => /*#__PURE__*/React.createElement(Action, {
  size: "sm",
  variant: "flat",
  className: "asurion-ui-callout-compression-button",
  onClick: onClick
}, isCompressed ? 'Show more' : 'Show less', isCompressed ? /*#__PURE__*/React.createElement(Icon.SSR, {
  src: "chevron-down"
}) : /*#__PURE__*/React.createElement(Icon.SSR, {
  src: "chevron-up"
}));
export const CalloutActions = ({
  primaryButton,
  secondaryButton,
  primaryAction,
  secondaryAction,
  linkOne,
  compressionEnabled,
  isCompressed,
  setIsCompressed
}) => {
  const hasAction = primaryButton || secondaryButton || primaryAction || secondaryAction || linkOne;
  if (!hasAction && !compressionEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ButtonContainer, null, !compressionEnabled ? /*#__PURE__*/React.createElement(ActionsOrLink, {
    primaryButton,
    secondaryButton,
    primaryAction,
    secondaryAction,
    linkOne
  }) : /*#__PURE__*/React.createElement(CompressButton, {
    isCompressed: isCompressed,
    onClick: () => setIsCompressed(compressed => !compressed)
  }));
};